export default __webpack_public_path__ + "static/media/about_icon5.258238ea.svg";